import { Input, List } from 'antd';
import { _debounce } from 'helpers/debounce';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AnalysisRow, fetchAnalysesByPatient } from 'services/api/analyses';

import ResultItem from './ResultItem';
import { showRestError } from 'utils/showErrorMessage';

interface IProps {
  patientId: number | string;
}

const PAGE_LIMIT = 10;
const debounce = _debounce();

const TestResults: FC<IProps> = ({ patientId }) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [results, setResults] = useState<AnalysisRow[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchAnalysesByPatient(patientId, {
      page,
      limit: PAGE_LIMIT,
      search: search || undefined
    })
      .then(res => {
        setResults(res.results);
        setTotal(res.total);
      })
      .catch(err => showRestError(err))
      .finally(() => setLoading(false));
  }, [page, patientId, search]);

  const onSearch = (value: string) => {
    setPage(1);
    debounce(() => setSearch(value));
  };

  return (
    <div>
      <List
        pagination={
          !!results.length && {
            position: 'bottom',
            align: 'center',
            total,
            pageSize: PAGE_LIMIT,
            current: page,
            onChange: p => setPage(p)
          }
        }
        itemLayout="horizontal"
        dataSource={results}
        loading={loading}
        header={
          <Input
            size="large"
            placeholder={t('patient.search_by_title')}
            onChange={e => onSearch(e.target.value)}
          />
        }
        renderItem={item => {
          if (!item.id) {
            return null;
          }

          return (
            <ResultItem
              key={item.id}
              date={item.createdAt}
              name={item.title || ''}
              id={item.id}
            />
          );
        }}
      />
    </div>
  );
};

export default TestResults;
